import React, { useRef } from "react";
import GlobalStyle from "../../styles/GlobalStyle";
import {
  scaleHorizontal,
  FontSizes,
  scaleVertical,
  scaleModerate,
} from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { PALLETTE } from "../../utils/theme";
import { RxIconSvg } from "../../utils/Svgs";

const RenderPoints = ({ item }: { item: string }) => {
  return (
    <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(5) }}>
      <div
        style={{
          width: scaleModerate(2),
          height: scaleModerate(2),
          borderRadius: "50%", // Standard for circles in CSS
          backgroundColor: PALLETTE.gray,
        }}
      />

      <span
        style={{
          ...GlobalStyle.blackMediumText,
          color: PALLETTE.gray,
          fontSize: "1.8rem",
          width: "96%",
        }}
      >
        {item}
      </span>
    </div>
  );
};

const Precaution = ({
  data,
  fireEvent,
}: {
  data: any[];
  fireEvent?: () => void;
}) => {
  return (
    <div>
      <div style={{ ...V2ReportStyle.card, gap: scaleVertical(10) }}>
        <div
          style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(5) }}
        >
          <span
            style={{
              ...GlobalStyle.blackBoldText,
              fontSize: "2rem",
              color: PALLETTE.gray,
            }}
          >
            HealthSetGo
          </span>
          <RxIconSvg />
        </div>

        <div
          style={{
            ...V2ReportStyle.flexColumnCenter,
            gap: scaleVertical(8),
            paddingLeft: scaleHorizontal(8),
          }}
        >
          {data?.map((item, index) => {
            return <RenderPoints key={index} item={item} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Precaution;
